module.exports = __webpack_public_path__ + "static/media/add2.1d8de24e.svg";